import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14e613f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "crisis-plan-card-wrapper" }
const _hoisted_2 = { class: "heading heading-sm" }
const _hoisted_3 = { class: "description" }
const _hoisted_4 = {
  key: 0,
  class: "small plan-completed-date"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spacer" }, "|", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconTasks = _resolveComponent("IconTasks")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CardCircleIcon = _resolveComponent("CardCircleIcon")!
  const _component_HistoryChoiceModal = _resolveComponent("HistoryChoiceModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CardCircleIcon, { "border-top": true }, {
      icon: _withCtx(() => [
        _createVNode(_component_IconTasks, { class: "card-icon icon-tasks" })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('title')), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('description')), 1),
        (_ctx.crisisPlanCompleted)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('history', { date: _ctx.completedDateString })), 1))
          : _createCommentVNode("", true),
        (!_ctx.crisisPlanCompleted)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              class: "btn-cta btn-link btn-create-activity",
              to: { name: _ctx.activityRouteName, params: { activitySlug: _ctx.crisisActivitySlug }}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('create_link')), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        (_ctx.crisisPlanCompleted)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "btn-cta btn-link btn-view-activity-response",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showCompletedActivityModal && _ctx.showCompletedActivityModal(...args)))
            }, _toDisplayString(_ctx.$t('view_link')), 1))
          : _createCommentVNode("", true),
        (_ctx.showDismiss)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _hoisted_5,
              _createElementVNode("button", {
                class: "btn-cta btn-link btn-dismiss",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doCardDismissal(_ctx.card.type)))
              }, _toDisplayString(_ctx.$t('dismiss_link')), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_HistoryChoiceModal, {
      activitySlug: _ctx.crisisActivitySlug,
      showNavigationModal: _ctx.showNavigationModal,
      activityRouteName: _ctx.activityRouteName,
      currentLocation: _ctx.currentLocation,
      "onUpdate:showModal": _ctx.updateShowNavigationModal
    }, null, 8, ["activitySlug", "showNavigationModal", "activityRouteName", "currentLocation", "onUpdate:showModal"])
  ]))
}